 <div class="card p-3 m-3 main-card">
  <div class="card-body main-body p-0">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3 col-xxl-3">
        <div class="row">
          <div class="col col-xxl-10">
            <div class="mb-3">
              <label class="form-label" i18n>User name</label>
              <val-text-box #v [(value)]="userName" i18n-placeholder placeholder="User name">
                <val-validation>
                  <ng-template valValidator="required" i18n-valvMessage valvMessage="Required field"></ng-template>
                </val-validation>
              </val-text-box>
            </div>
            <div class="mb-3">
              <label class="form-label" i18n>Email</label>
              <val-text-box #v [(value)]="email" i18n-placeholder placeholder="Email">
                <val-validation>
                  <ng-template valValidator="email" i18n-valvMessage valvMessage="Incorrect email"></ng-template>
                </val-validation>
              </val-text-box>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <button (click)="send()" class="btn btn-primary" i18n>Request new password</button>
          <button routerLink="/login" class="btn btn-link float-end" i18n>Login</button>
        </div>
        <div *ngIf="success" class="alert alert-success mb-3" role="alert" i18n>Please check your email for new password</div>
      </div>
    </div>
  </div>
</div>